import { isServer } from '@commons/utils';

export const getWindowObject = () => (isServer() ? null : window);
